import { render, staticRenderFns } from "./ApplicationForms.vue?vue&type=template&id=33931fc4&scoped=true&"
import script from "./ApplicationForms.vue?vue&type=script&lang=js&"
export * from "./ApplicationForms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33931fc4",
  null
  
)

export default component.exports